// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {Link} from 'react-router-dom';


class AddTournamentTeamMember extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      tournament_id: props.tournament_id,
      team_id: props.team_id,
      team_name: props.team_name,
      customer_search_list: [],
      tournaments: [],
      tournament_teams: [],
      team_members: [],
      tournament_details: {
        mobile_no: '',
        customer_id: '',
        name: '',
        tournament_team: props.team_id,
        amount: 0,
        cust_name: '',
        cust_mobile_no: '',
      },
      venues: [],
      data_uploaded: false,
      data_error: false,
      search: false,
      dialog_open: false,
      addPlayerView:true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);

    this.styles = {
          chip: {
            margin: 4,
          },
          wrapper: {
            display: 'flex',
            flexWrap: 'wrap',
          },
        };
  }

  componentDidMount() {
    console.log(this.state);
  }


  getSearchList(mobile_no) {
    const url = `${getLocationOrigin()}/eagleeye/search/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'search': mobile_no
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_search_list: data.results, search: true}))
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }

  postaddTournamentMember(data, props) {
    console.log(data);
    const url = `${getLocationOrigin()}/eagleeye/add_tournament_member/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'customer_list': this.state.team_members,
                        'tournament_team': data.tournament_team,
                        'amount': data.amount,
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          window.location.reload();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleOpen = () => {
    this.setState({dialog_open: true});
  };

  handleClose = () => {
    this.setState({dialog_open: false});
  };

  handleChange(event) {
    console.log(event.target.name,event.target.value)
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one[name] = event.target.value
    this.setState({tournament_details: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postaddTournamentMember(this.state.tournament_details, this.props);
    console.log('post');
    console.log(this.state);
  }

  handleCustomerSubmit(){
    console.log('post');
    console.log(this.state.tournament_details.cust_name);
    console.log(this.state.tournament_details.cust_mobile_no);

    const url = `${getLocationOrigin()}/eagleeye/add_new_customer_tournament/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'customer_name': this.state.tournament_details.cust_name,
                        'customer_mobile': this.state.tournament_details.cust_mobile_no,
                        'tournament_id': this.state.tournament_id,
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch(error => {
        console.log(error);
        alert(error.message);
      })
      .then(data => {
        if(data.success){
          var team_members = Object.assign([], this.state.team_members);
          team_members.push({'id': data.customer.id, 'name': data.customer.name, 'photo': "http://www.sporthood.in/assets/img/avatar.png"});
          this.setState({team_members: team_members});
          alert(data.message);
          this.handleClose();
        } else {
          alert(data.message);
        }
       });
  }

  searchCustomer() {
    {this.state.tournament_details.mobile_no?this.getSearchList(this.state.tournament_details.mobile_no):
      alert('Search cannot be blank')}
  }

  setSearch(name, mobile, id){
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    var team_members = Object.assign([], this.state.team_members);
    team_members.push({'id': id, 'name': name, 'photo': "http://www.sporthood.in/assets/img/avatar.png"});
    new_selected_one['mobile_no'] = mobile
    new_selected_one['name'] = name
    new_selected_one['customer_id'] = id
    this.setState({tournament_details: new_selected_one, search: false, team_members: team_members});

  }

  handleRequestDelete = (key) => {
    var team_members = Object.assign([], this.state.team_members);
    console.log(team_members);
    const chipToDelete = team_members.findIndex(chip => chip.id==key);
    team_members.splice(chipToDelete, 1);
    this.setState({team_members: team_members});
  };
  toAdd(){
    this.setState({addPlayerView:!this.state.addPlayerView})
  }

  renderChip(data) {
    
    return (
      <Chip
        key={data.id}
        onRequestDelete={() => this.handleRequestDelete(data.id)}
        style={this.styles.chip}
      >
        <Avatar id={data.id} src={data.photo=='http://www.sporthood.in/assets/img/avatar.png'?data.photo:
        `https://api.sporthood.in/${data.photo}`} />
        {data.name}
      </Chip>
    );
  }

  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.handleCustomerSubmit}
      />,
    ];
    console.log("her in render");
    console.log(this.state.team_members);
    return(
      <div >
      {this.state.addPlayerView && 
           <Dialog
                                        modal={false}
                                        open={true}
                                        autoDetectWindowHeight={true}
                                        autoScrollBodyContent={true}
                                        scroll={scroll}
                                        dividers={scroll === 'paper'}
                                      >

        <div className="row col-md-12" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add Team Member</h3>
          </div>
          {/*
          <div style={{flexDirection: 'column', }}>   
                    <button className="btn" style={{border: 'none', backgroundColor: '#fff', float: 'left', margin: '13px'}}>
                    <Link to={`/crud/childProfile/${this.state.tournament_details.mobile_no}`}> <i className="fa fa-plus-circle" style={{fontSize: 'large'}}></i>
                    <span style={{fontSize: '100%', fontWeight: 600, margin: '4px'}}>Add Kid Profile</span>
                    </Link>
                    </button>
               </div> */}
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer Search
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="mobile_no" className="form-control"
                  placeholder="Search for.. " value={this.state.tournament_details.mobile_no} onChange={this.handleChange}/>
                <span className="input-group-btn">
                  <button className="btn btn-default glyphicon glyphicon-search"
                  type="button" onClick={this.searchCustomer}></button>
                </span>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              {this.state.search?
                <div className="col-md-12 btn-group">
                  {this.state.customer_search_list.length?this.state.customer_search_list.map((x) =>(<button key={x.id} className="btn btn-default"
              style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.mobile_no, x.id)}>{x.name}:{x.mobile_no}</button>))
              :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                  <div>Search customer not found</div>
                  <div>
                    <RaisedButton
                      onClick={this.handleOpen}
                      label="Add User"
                      style={{float:'right'}}
                      secondary={true}
                    />
                    <Dialog
                      actions={actions}
                      modal={false}
                      open={this.state.dialog_open}
                      onRequestClose={this.handleClose}
                    >
                      <div>
                        <div style={styles.main_header} className="col-md-12">
                          <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                        </div>
                        <div style={styles.items} className="col-md-12">
                          <div style={styles.item_header} className="col-md-6">
                            Name
                          </div>
                          <input type="text" style={styles.input} name="cust_name" className="required"
                            value={this.state.value} onChange={this.handleChange}/>
                        </div>

                        <div style={styles.items} className="col-md-12">
                          <div style={styles.item_header} className="col-md-6">
                            Mobile No
                          </div>
                          <input type="number" style={styles.input} name="cust_mobile_no" className="required"
                            value={this.state.value} onChange={this.handleChange}/>
                        </div>
                      </div>
                    </Dialog>
                  </div>
              </div>
            }
              </div>
              : <div></div>
            }
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Selected Players
              </div>
              <div className="col-md-6" style={styles.item_body}>
                <div style={this.styles.wrapper}>
                  {this.state.team_members.map(this.renderChip, this)}
                </div>
              </div>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Tournament Team
              </div>
              <div className="col-md-6" style={styles.item_body}>
                {this.state.team_name}
              </div>
            </div>

            {/*
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Amount Collected/Player
              </div>
              <input type="number" style={styles.input} name="amount" className="required"
                value={this.state.value} onChange={this.handleChange}/>
            </div>
          */}

            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit" />
              <input type="button" className="button1" value="Cancel" style={{backgroundColor:'red',color:'#ffffff'}} onClick={() => {this.toAdd()}} />
            </div>
          </form>
        </div>
        </Dialog>
      }
      </div>
    );
  }
}

export default AddTournamentTeamMember;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournamentTeamMember/index.js